export const MAX_PREVIOUS_MESSAGES = 5;
export const MAX_MESSAGE_LENGTH = 3000;

function splitRaw(input: string): string[] {
  if (!input?.trim()) return [];
  const groups: string[] = [];
  let current: string[] = [];
  for (const line of input.split('\n')) {
    if (/^\s*---\s*$/.test(line)) {
      groups.push(current.join('\n').trim());
      current = [];
    } else {
      current.push(line);
    }
  }
  groups.push(current.join('\n').trim());
  return groups.filter((m) => m.length > 0);
}

export function parsePreviousMessages(input: string): string[] {
  return splitRaw(input)
    .slice(0, MAX_PREVIOUS_MESSAGES)
    .map((m) => (m.length > MAX_MESSAGE_LENGTH ? m.slice(0, MAX_MESSAGE_LENGTH) : m));
}

export function countMessages(input: string): number {
  return splitRaw(input).length;
}

export function hasOverLengthMessage(input: string): boolean {
  return splitRaw(input).some((m) => m.length > MAX_MESSAGE_LENGTH);
}
